import React from 'react';
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="mb-1">{t("login.pageTexts.header.title")}</h4>
      <p className="mb-5">{t("login.pageTexts.header.subTitle")}</p>
    </>
  )
};

export default Header;